// extracted by mini-css-extract-plugin
module.exports = {"baseAction":"_1nKPkQmR","container":"_2dN6NFE1","tooltip":"_3qdXKrH7","openInNewTab":"_1GGwUM9e"};